import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { useStore } from "@nanostores/react"
import { H5, Small, Tiny } from "@/components/standard/BFText"
import { View } from "react-native"
import { BFCloseButton } from "@/components/standard/BFCloseButton"
import * as React from "react"
import { persistentAtom } from "@nanostores/persistent"
import SignClipart from "@/assets/clipart/sold-sign.svg"
import { createComponentClickedEvent, track } from "@/analytics/events/base"

export const $orchardWidget = persistentAtom<"true" | "false">(
  "orchardWidget",
  "true"
)

export const OrchardWidget = () => {
  const { loanApplication } = useLoanContext()
  const shouldShow = useStore($orchardWidget)

  if (shouldShow === "false" || loanApplication.creditScore !== "Below 640") {
    return null
  }

  return (
    <Vertical
      className={"border border-light-grey rounded-md pt-6 relative bg-white"}
    >
      <Horizontal className={"justify-between w-full  px-5"}>
        <Vertical className={"flex-1 pb-6 gap-1"}>
          <H5 color={"primary"}>Close on-time with Orchard</H5>
          <Small color={"primary"}>
            Use our fully integrated title partner for a seamless and worry-free
            closing.
          </Small>
        </Vertical>
        <View className={"px-4 justify-center items-center"}>
          <SignClipart />
        </View>
      </Horizontal>
      <View className="absolute top-3 right-3 size-4">
        <BFCloseButton
          dark={true}
          onPress={() => {
            track(
              createComponentClickedEvent({
                current_screen: "Loan Dashboard",
                component_id: "orchard-close",
                component_type: "text_link",
                component_function: "close orchard widget",
              })
            )
            $orchardWidget.set("false")
          }}
        />
      </View>
      <Horizontal className={"px-4 py-3  bg-grey items-center justify-between"}>
        <Tiny color={"disabled"}>Ask your Backflip lender for details</Tiny>
      </Horizontal>
    </Vertical>
  )
}
